var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    fill: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "API---option-1",
    transform: "translate(-1112.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People",
    transform: "translate(1109.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,15 L4.5,15 C4.05,15 3.75,14.7 3.75,14.25 L3.75,13.5 C3.75,11.7 4.65,10.05 6.075,9.15 C5.55,8.475 5.25,7.65 5.25,6.75 C5.25,4.65 6.9,3 9,3 C11.1,3 12.75,4.65 12.75,6.75 C12.75,7.65 12.45,8.475 11.925,9.15 C13.35,10.125 14.25,11.775 14.25,13.5 L14.25,14.25 C14.25,14.7 13.95,15 13.5,15 L13.5,15 Z M5.25,13.5 L12.75,13.5 C12.75,11.925 11.775,10.575 10.35,9.975 C10.05,9.9 9.9,9.6 9.9,9.375 C9.9,9.075 9.975,8.85 10.275,8.7 C10.875,8.25 11.25,7.5 11.25,6.75 C11.25,5.475 10.275,4.5 9,4.5 C7.725,4.5 6.75,5.475 6.75,6.75 C6.75,7.5 7.125,8.25 7.8,8.625 C8.025,8.775 8.175,9.075 8.175,9.3 C8.175,9.6 7.95,9.825 7.725,9.9 C6.225,10.575 5.25,11.925 5.25,13.5 L5.25,13.5 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Account.99d15de5604bae7bda353ea883a2b67f.svg";